import { useState } from "react";

// Import images
import w8_8 from "../assets/w8-8.jpg";
import s1 from "../assets/s1.jpg";
import s2 from "../assets/s2.jpg";
import s3 from "../assets/s3.jpg";
import s4 from "../assets/s4.jpg";
import s5 from "../assets/s5.jpg";
import s6 from "../assets/s6.jpg";
import s7 from "../assets/s7.jpg";

// Array of slides with alternating text and images
const slides = [
    { type: "text", title: "Spindle Maintenance"},

    { type: "image", src: s1 },
    { type: "image", src: s2 },
    { type: "image", src: s3 },
    { type: "image", src: s4 },
    { type: "image", src: s5 },
    { type: "image", src: s6 },
    { type: "image", src: s7 },
    { type: "image", src: w8_8 },


  ];
  

export default function ImageGallery5() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="max-w-[800px] mx-auto mt-10">
      {/* Slide Content: Either Text or Image */}
      {slides[currentIndex].type === "text" ? (
        <div className="bg-gray-100 p-6 rounded-lg shadow-md flex items-center justify-center text-center w-full h-[400px]">
          <div>
            <h2 className="text-xl font-semibold mb-2">{slides[currentIndex].title}</h2>
            <p className="text-gray-600">{slides[currentIndex].description}</p>
          </div>
        </div>
      ) : (
        <div className="relative w-full h-[400px]">
          <img
            src={slides[currentIndex].src}
            alt={`Slide ${currentIndex + 1}`}
            className="rounded-lg shadow-lg w-full h-full object-contain"
          />
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex justify-between mt-4">
        <button
          onClick={prevSlide}
          className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
        >
          ◀ Previous
        </button>
        <button
          onClick={nextSlide}
          className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
        >
          Next ▶
        </button>
      </div>

      {/* Indicator Dots */}
      <div className="flex justify-center mt-4 space-x-2">
        {slides.map((_, index) => (
          <div
            key={index}
            className={
                "w-3 h-3 rounded-full " + (index === currentIndex ? "bg-gray-800" : "bg-gray-400")
              }              
          ></div>
        ))}
      </div>
    </div>
  );
}
